(function ($) {

  $(document).on('DOMContentLoaded', function(){
    setTimeout(() => {
      setHeight();
    }, 50);
  });

  $(window).on('resize', function () {
    setHeight();
  });

  function setHeight(){
    let maxHeight = 0;
    
    $('.js-keyfigure').find('.js-keyfigure-title').each(function() {

      $(this).css("height", "auto");
      
      if($(this).height() > maxHeight){
        maxHeight = $(this).outerHeight();
      }
      
    });

    $('.js-keyfigure').find('.js-keyfigure-title').each(function() {
      $(this).css("height", maxHeight);
    });
    
  }
})(jQuery);